module.exports = __webpack_public_path__ + "img/mt4-icon4.6003239.png";